interface SentryLogger {
  info: (message: string, attributes?: Record<string, unknown>) => void;
  warn: (message: string, attributes?: Record<string, unknown>) => void;
  error: (message: string, attributes?: Record<string, unknown>) => void;
}

type LogAttributes = Record<string, unknown>;

export function createLog(sentryLogger?: SentryLogger) {
  return {
    info: (message: string, attributes?: LogAttributes, { logToConsole = true }: { logToConsole?: boolean } = {}) => {
      logToConsole && console.info(message, attributes);
      sentryLogger?.info(message, attributes);
    },
    warn: (message: string, attributes?: LogAttributes, { logToConsole = true }: { logToConsole?: boolean } = {}) => {
      logToConsole && console.warn(message, attributes);
      sentryLogger?.warn(message, attributes);
    },
    error: (message: string, attributes?: LogAttributes, { logToConsole = true }: { logToConsole?: boolean } = {}) => {
      logToConsole && console.error(message, attributes);
      sentryLogger?.error(message, attributes);
    },
  };
}
